<template>
  <v-content>
    <router-view id="content-wrap" />

    <v-img id="dashboard-core-footer" src="@/assets/powered-by-norven.svg" contain height="24" width="200" />
  </v-content>
</template>

<script>
  export default {
    name: 'DashboardCoreView'
  };
</script>

<style scoped>
  #content-wrap {
    margin-bottom: 38px;
  }

  #dashboard-core-footer {
    position: absolute;
    left: 32px;
    bottom: 8px;
  }
</style>
